import { render, staticRenderFns } from "./ReportProposal.vue?vue&type=template&id=5b590802"
import script from "./ReportProposal.vue?vue&type=script&lang=js"
export * from "./ReportProposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports